import { useSelector } from 'Flux/index.js'
import type { State } from 'Flux/Slice/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { OrderNotice } from '../../../../Generated/OrderNotice.ts'

const NONE: OrderNotice[] = []

const selectNotices = (state: typeof State) => state[orderSlice.name].notices

/** The notices of [orderId], empty until they have loaded or when they belong to another order. */
export const useOrderNotices = (orderId: string | undefined): OrderNotice[] => {
  const notices = useSelector(selectNotices)
  return notices && notices.orderId === orderId ? notices.items : NONE
}
